<template>
  <div class="pb-3">
    <label v-if="label" class="text-primary mb-1">{{label}}</label>
    <b-row v-if="unit.toLowerCase() === 'hour'" >
      <b-col>
        <b-form-row>
          <b-col>
            <b-form-input
              v-if="isPlaintext" :plaintext="isPlaintext"
              :value="hours" @input="handleInput($event, 'h')"
              type="number" min="0" max="23" id="input-horizontal" class="col">

            </b-form-input>
            <b-form-select
              v-else
              :disabled="disabled"
              :value="hours"
              :options="optionHours"
              @input="handleInput($event, 'h')"
              type="number"
              min="0" max="23" step="1"
              id="input-horizontal"
              class="col"
              :class="{'is-invalid': validation.$invalid}"
              lang="en-US"
            >
            </b-form-select>
          </b-col>
          <b-col v-if="!label" cols="3" class="d-flex">
            <label class="my-auto text-uppercase">HRS</label>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col :class="{'is-invalid': validation.$invalid}">
        <b-form-row>
          <b-col>
            <b-form-input
              v-if="isPlaintext" :plaintext="isPlaintext" :value="minutes"
              @input="handleInput($event, 'm')" type="number" min="0"
              max="59" id="input-horizontal" class="col">
            </b-form-input>
            <b-form-select
              v-else
              :disabled="disabled"
              :value="minutes"
              :options="optionMin"
              value-field="value"
              text-field="text"
              @input="handleInput($event, 'm')"
              type="number"
              min="0" max="59" step="1"
              id="input-horizontal"
              class="col"
              :class="{'is-invalid': validation.$invalid}"
              lang="en-US"
            >
            </b-form-select>
          </b-col>
          <b-col v-if="!label" cols="3" class="d-flex">
            <label class="my-auto text-uppercase">MIN</label>
          </b-col>
        </b-form-row>
      </b-col>
      <AppFormFeedback v-if="!disabled" :errors="validation"/>
    </b-row>

    <b-row v-if="unit.toLowerCase() === 'day'">
      <b-col>
        <b-form-row :class="{'is-invalid': validation.$invalid}">
          <b-col>
            <b-form-input
              v-if="isPlaintext"
              :plaintext="isPlaintext"
              :value="days | removeDecimalIfNotNecessary"
              type="number"
              id="input-horizontal"
              class="col"/>
            <b-form-select
              v-else
              :disabled="disabled"
              :value="days"
              :options="[]"
              @input="handleInput($event, 'd')"
              type="number"
              min="0" max="1" step="0.5"
              id="input-horizontal"
              class="col"
              :class="{'is-invalid': validation.$invalid}"
              lang="en-US"
            >
              <b-form-select-option v-if="!isHalfDay" value="1.00">1</b-form-select-option>
              <b-form-select-option value="0.50">0,5</b-form-select-option>
              <b-form-select-option value="0.00">0</b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col v-if="!label" cols="5" class="d-flex">
            <label class="my-auto text-uppercase">days</label>
          </b-col>
        </b-form-row>
        <AppFormFeedback v-if="!disabled" :errors="validation"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  export default {
    name: "TimesheetTimeInput",
    components: {AppFormFeedback},
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      validation:{
        type: Object,
        default: function () {
          return {}
        }
      },
      value: null,
      unit: {
        type: String,
        default: 'Hour'
      },
      label: null,
      disabled: {
        type: Boolean,
        default: false
      },
      isHalfDay: {
        type: Boolean,
        default: false
      },
      isPlaintext: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        hours: 0,
        minutes: 0,
        days: 0,
        optionHours: [],
        optionMin: []
      }
    },
    methods: {
      concatenateHoursAndMinutes() {
        let intValue = parseInt(this.hours);
        let fromMinutesToHours = Math.round(this.minutes/60*100)/100;
          intValue += fromMinutesToHours;
        return intValue.toString();
      },
      handleInput (input, from) {
        let stringValue = "";
        switch (from) {
          case 'h':
            this.hours = input;
            stringValue = this.concatenateHoursAndMinutes();
            break;
          case 'm':
            this.minutes = input;
            stringValue = this.concatenateHoursAndMinutes();
            break;
          case 'd':
            this.days = parseFloat(input).toFixed(2);
            stringValue = this.days;
            break;
        }
        this.$emit('input', stringValue);
      },
      formatValue() {
        if (this.unit.toLowerCase() === 'hour') {
          this.hours = this.value ? this.value.split('.')[0] : 0;
          let hoursToConvertToMinutes = this.value && this.hours != 0?this.value % this.hours:this.value;
          this.minutes = this.value ? Math.round(hoursToConvertToMinutes*60) : 0;
          if (this.minutes.toString().length == 1 ) {
            this.minutes = "0" + this.minutes;
          }
        } else if (this.unit.toLowerCase() === 'day') {
          this.days = parseFloat(this.value).toFixed(2);
        }
      }
    },
    watch: {
      value() {
        this.formatValue();
      }
    },
    created() {
      this.formatValue();
      for(let i = 0; i < 24; i++){
        this.optionHours.push({'text': i, 'value': i})
      }
      for(let i = 0; i < 60; i++){
        if(i < 10){
          this.optionMin.push({'text': "0" +i, 'value': "0" + i});
        } else {
          this.optionMin.push({'text': i, 'value': i});
        }
      }
    }
  }
</script>

<style scoped>

</style>
